import React, { useState } from 'react';
import { Card, Alert, Dropdown, ButtonGroup, Button } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';

const ClusterCard = ({ cluster, onClusterAction, onEdit, onDelete }) => {
    const { hasPermission } = useAuth();
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });

    const handleAction = async (action) => {
        try {
            const success = await onClusterAction(cluster.id, action);
            if (success) {
                setAlert({ show: true, message: `${action} sent to cluster successfully!`, variant: 'success' });
            } else {
                setAlert({ show: true, message: `Failed to ${action} cluster.`, variant: 'danger' });
            }
            setTimeout(() => setAlert({ show: false, message: '', variant: 'success' }), 3000);
        } catch (err) {
            setAlert({ show: true, message: `Failed to ${action} cluster`, variant: 'danger' });
            setTimeout(() => setAlert({ show: false, message: '', variant: 'success' }), 3000);
        }
    };

    return (
        <Card className="glass-card h-100">
            <Card.Body className="d-flex flex-column" style={{ padding: '1.5rem' }}>
                {alert.show && (
                    <Alert 
                        variant={alert.variant} 
                        onClose={() => setAlert({ ...alert, show: false })} 
                        dismissible 
                        className="mb-3 border-0 py-2"
                        style={{
                            backgroundColor: alert.variant === 'success' ? 'rgba(16, 185, 129, 0.12)' : 'rgba(244, 63, 94, 0.12)',
                            color: alert.variant === 'success' ? 'var(--color-success)' : 'var(--color-danger)',
                            fontSize: '0.8rem',
                            borderRadius: 'var(--radius-md)'
                        }}
                    >
                        {alert.message}
                    </Alert>
                )}
                
                <div className="mb-4">
                    <div className="d-flex justify-content-between align-items-start mb-2.5">
                        <h5 className="mb-0 text-theme-main" style={{ fontWeight: 700, fontSize: '1.1rem' }}>
                            <i className="fas fa-layer-group me-2 text-theme-highlight"></i>
                            {cluster.name}
                        </h5>
                        <span 
                            style={{
                                background: 'rgba(59, 130, 246, 0.1)',
                                border: '1px solid var(--border-color)',
                                color: 'var(--text-highlight)',
                                fontSize: '0.75rem',
                                fontWeight: 600,
                                padding: '0.25rem 0.6rem',
                                borderRadius: '20px'
                            }}
                        >
                            {cluster.machine_count || 0} Assets
                        </span>
                    </div>
                    <p className="text-theme-muted mb-0" style={{ fontSize: '0.85rem', lineHeight: '1.4' }}>
                        {cluster.description || 'No description provided.'}
                    </p>
                </div>
                
                <div className="mt-auto d-flex justify-content-between align-items-center pt-3" style={{ borderTop: '1px solid var(--border-color)' }}>
                    <div className="d-flex gap-2 w-100">
                        <Dropdown as={ButtonGroup} size="sm" className="w-100">
                            <Button 
                                onClick={() => handleAction('wake')} 
                                className="btn-premium-primary py-1.5 w-100"
                                style={{ fontSize: '0.8rem' }}
                                disabled={!hasPermission('power')}
                            >
                                <i className="fas fa-play me-1"></i>Start Group
                            </Button>
                            <Dropdown.Toggle split className="btn-premium-primary py-1.5" disabled={!hasPermission('power') && !hasPermission('manage_assets')} />
                            <Dropdown.Menu style={{ background: 'var(--dropdown-bg)', border: '1px solid var(--border-color)', width: '200px' }}>
                                {hasPermission('power') && (
                                    <>
                                        <Dropdown.Item onClick={() => handleAction('shutdown')} className="text-danger py-2">
                                            <i className="fas fa-power-off me-2"></i>Shutdown Group
                                        </Dropdown.Item>
                                        <Dropdown.Item onClick={() => handleAction('restart')} className="text-warning py-2">
                                            <i className="fas fa-redo me-2"></i>Restart Group
                                        </Dropdown.Item>
                                    </>
                                )}
                                {hasPermission('power') && hasPermission('manage_assets') && (
                                    <Dropdown.Divider style={{ borderColor: 'var(--border-color)' }} />
                                )}
                                {hasPermission('manage_assets') && (
                                    <>
                                        <Dropdown.Item onClick={() => onEdit(cluster)} className="text-theme-main py-2">
                                            <i className="fas fa-edit me-2"></i>Configure Group
                                        </Dropdown.Item>
                                        <Dropdown.Item onClick={() => onDelete(cluster.id)} className="text-danger py-2">
                                            <i className="fas fa-trash me-2"></i>Delete Group
                                        </Dropdown.Item>
                                    </>
                                )}
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
};

export default ClusterCard;